var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import KendoBaseComponent from '@progress/kendo-base-component-react-wrapper';
var Menu = (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Menu.prototype.componentDidMount = function () {
        var domNode = ReactDOM.findDOMNode(this);
        var _a = this.props, children = _a.children, widgetRef = _a.widgetRef, props = __rest(_a, ["children", "widgetRef"]);
        if (domNode) {
            this.widgetInstance = new kendo.ui.Menu(domNode, props);
            _super.prototype.componentDidMount.call(this);
        }
    };
    Menu.prototype.componentWillReceiveProps = function (nextProps) {
        var children = nextProps.children, widgetRef = nextProps.widgetRef, props = __rest(nextProps, ["children", "widgetRef"]);
        var widget = this.widgetInstance;
        if (props.dataSource && props.dataSource === widget.options.dataSource) {
            delete props.dataSource;
        }
        this.widgetInstance.setOptions(props);
    };
    Menu.prototype.render = function () {
        return (React.createElement("ul", null, this.props.children));
    };
    return Menu;
}(KendoBaseComponent));
export default Menu;
//# sourceMappingURL=menu.js.map